import { assert } from '@ember/debug';
import { computed } from '@ember/object';

/**
 * Returns a computed property that reads from a CSS custom property on `this.element`.
 *
 * @function cssNumericalProperty
 * @param {String} name the name of the CSS property to read
 * @returns {Function} a computed property to assign to your Ember component
 */
export default function cssNumericalProperty(name, defaultValue = null) {
  return computed('element', function () {
    if (!this.element) {
      return defaultValue;
    }

    // Try to get the CSS custom property from the element or its ancestors
    let element = this.element;
    let value = '';

    // Walk up the DOM tree until we find a value or run out of elements
    while (element && !value) {
      const computedValue = getComputedStyle(element).getPropertyValue(name);
      const trimmed = computedValue ? computedValue.toString().trim() : '';
      if (trimmed && trimmed.match(/\d+\.?\d*/)) {
        value = trimmed;
        break;
      }
      element = element.parentElement;
    }
    if (!value) {
      assert(`cssNumericalProperty could not find a value for "${name}" and no defaultValue was provided`, defaultValue !== null);
      return defaultValue;
    }
    const match = value.match(/\d+\.?\d*/);
    if (!match || !match[0]) {
      return defaultValue;
    }
    return Number.parseFloat(match[0]);
  });
}